import { useDrag, useDrop } from 'react-dnd';
import { IconButton, Stack, Typography } from '@mui/material';
import { DotsSixVertical, X } from '@phosphor-icons/react';
import * as React from 'react';
import { DataGridColumn } from '../../../shared';

type Field = DataGridColumn<any, any> & {id: string};

interface FieldRowProps {
  field: Field;
  onDeleteClick: () => void;
  moveField: (id: string, to: number) => void
  findField: (id: string) => { index: number }
}

export const FieldRow = ({field, onDeleteClick, findField, moveField}: FieldRowProps) => {
  const originalIndex = findField(field.id).index
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: 'field',
      item: { id: field.id, originalIndex },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
      end: (item, monitor) => {
        const { id: droppedId, originalIndex } = item
        const didDrop = monitor.didDrop()
        if (!didDrop) {
          moveField(droppedId, originalIndex)
        }
      },
    }),
    [field.id, originalIndex, moveField],
  )

  const [, drop] = useDrop(
    () => ({
      accept: 'field',
      hover({ id: draggedId }: Item) {
        if (draggedId !== field.id) {
          const { index: overIndex } = findField(field.id)
          moveField(draggedId, overIndex)
        }
      },

    }),
    [findField, moveField],
  )

  const opacity = isDragging ? 0 : 1

  return <Stack gap={1} direction={'row'} alignItems={'center'}
                ref={(node) => drag(drop(node))} style={{ opacity }}
                sx={{maxWidth: 300, overflow: 'hidden', p: '3px 8px'}}>
    <DotsSixVertical size={16} color="#a6a6a6" weight="bold" style={{cursor: 'grab'}} />
    <Typography variant={'body2'} fontWeight={500} color={'text.secondary'} sx={{flex: 1, mr: 1, cursor: 'default'}}>{field.title}</Typography>
    <IconButton size={'small'} onClick={onDeleteClick}>
      <X color={'#a6a6a6'} size={16} weight="bold" />
    </IconButton>
  </Stack>
}


interface Item {
  id: string
  originalIndex: number
}
